import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

// Endpoint #6 returns a CSV file (not JSON), so it is fetched as a blob. The
// filename comes from Content-Disposition, with a sensible fallback.
export const downloadPayoutReport = async (promotionId, batchId, outcome) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get(
    `/payment/admin/promotion-campaigns/${promotionId}/payouts/${batchId}/report`,
    { headers, params: { outcome }, responseType: 'blob' },
  );

  const disposition = response.headers?.['content-disposition'] || '';
  const match = /filename="?([^";]+)"?/.exec(disposition);
  const filename = match
    ? match[1]
    : `payout-report-${batchId}-${outcome}.csv`;

  return { blob: response.data, filename };
};
